import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Textarea } from '@rocketlane/ui';
import { Editor } from '@tiptap/react';
import React, { useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 370px;
  padding: var(--spacing-03);
  border-radius: var(--spacing-03);
  box-shadow: var(--shadow-16);
  z-index: 4000;
  background: var(--purple-10);
`;

const Title = styled.div`
  gap: var(--spacing-03);
  display: flex;
  align-items: center;
  color: var(--purple-70);
`;

const StyledTextArea = styled(Textarea)`
  height: 32px !important;
  border: none !important;
  padding: var(--spacing-04) var(--spacing-03) !important;
  background: var(--purple-10) !important;

  &:focus,
  &:hover {
    border: none !important;
    outline: none !important;
  }
`;

const AskAIButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const InspectorPopover = ({
  onClose,
  onOpenChat,
  // editor,
  // element,
}: {
  onClose?: () => void;
  onOpenChat?: (message: string) => void;
  editor?: Editor;
  element?: any;
}) => {
  const [value, setValue] = useState('');

  return (
    <Wrapper>
      <Title>
        <FontAwesomeIcon icon={faSparkles} size="xs" />
        <span>Ask AI</span>
      </Title>
      <StyledTextArea
        value={value}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            onOpenChat?.(value.trim());
            onClose?.();
          }
        }}
        onChange={(e) => setValue(e.target.value)}
        placeholder="What do you want to know?"
        rows={1}
        maxRows={5}
      />
      {value && (
        <AskAIButtonWrapper>
          <Button
            aria-label="Ask AI"
            leftIcon={<FontAwesomeIcon icon={faArrowRight} size="xs" />}
            size="small"
            variant="ai"
            onClick={() => {
              if (value.trim()) {
                onOpenChat?.(value.trim());
              }
              onClose?.();
            }}
          />
        </AskAIButtonWrapper>
      )}
    </Wrapper>
  );
};
